<template>
<div>
  <nav v-if="profileStyle" class="profile-footer-container" :class="brandClass">
    <div class="footer-elements">
      <div class="footer-element">
      <a
        v-if="c('link_legal_notice')"
        :href="c('link_legal_notice')"
        target="_blank"
        rel="noopener noreferrer"
        class="accessibility-padding"
        >{{ t("footer_legal_notice") }}</a
      >
    </div>
     <div class="footer-element">
      <a
        v-if="c('link_data_privacy')"
        :href="c('link_data_privacy')"
        target="_blank"
        rel="noopener noreferrer"
        class="accessibility-padding"
        >{{ t("footer_data_privacy") }}</a
      >
    </div> 
    <!-- <div class="footer-element">
      <a
        v-if="areEpaasAndTracyEnabled && isEpaasInitialized"
        target="_blank"
        class="accessibility-padding"
        @click="fireCookieEvent()"
        >{{ t("footer_cookie_policy") }}</a
      >
    </div> -->
    <div class="footer-element">
      <a
        v-if="c('link_imprint')"
        :href="c('link_imprint')"
        target="_blank"
        rel="noopener noreferrer"
        class="accessibility-padding"
        >{{ t("footer_imprint") }}</a
      >
    </div>
    <hr v-if="c('show_footer_settings')" alt="" role="presentation">
    <div class="footer-element footer-settings" v-if="c('show_footer_settings')"  :class="brandClass" >
       <OneTippy
        :brandClass="brandClass"
        :name="'settingPopupTrigger'"
        v-if="true"
        :showInfoIcon="false"
        :placement="'top-start'"
        :maxWidth="450"
        :labelledBy="'tooltip-label'"
      >
      <template v-slot:externalcontent>
        <div class="custom-alert-settings" :class="brandClass">
          <div class="custom-confirm-title-settings" :class="brandClass">
            {{ t("footer_settings_display_mode") }}
          </div>
          <div class="custom-confirm-content-settings" :class="brandClass">
            <div class="radio_settings_container">
              <div @keydown="ariaClick" aria-labelledby="darkmode-label" role="button" tabindex="0" class="radio_settings" @click="selectDarkMode(true)" :class="darkModeSelected && 'selected'"></div>
              <div class="radio_settings_label" id="darkmode-label" aria-hidden="true">{{t("footer_settings_darkmode")}}</div>
              <div @keydown="ariaClick" aria-labelledby="lightmode-label" role="button" tabindex="0" class="radio_settings" @click="selectDarkMode(false)" :class="!darkModeSelected && 'selected'"></div>
              <div class="radio_settings_label" id="lightmode-label" aria-hidden="true">{{t("footer_settings_lightmode")}}</div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:externaltriggeringelement>
        <a
          href="javascript:void(0)"
          :id="'settingPopupTrigger'"
          tabindex="0"
          @keydown="ariaClick"
          class="accessibility-padding"
          >{{ t("footer_settings") }}</a
        >
      </template>
      </OneTippy>
    </div>
    </div>
    <!-- <span>{{t("copyright_label").replace('${current_year}',new Date().getFullYear())}}</span> -->
  </nav>
  <nav v-else class="registration-footer-container" :class="brandClass">
    <hr :class="brandClass" alt="" role="presentation">
    <OneLanguageSelection v-if="c('show_language_selection')"  />
    <div class="registration-footer-element" :class="brandClass" v-if="c('link_legal_notice')">
          <a
            :href="c('link_legal_notice')"
            target="_blank"
            rel="noopener noreferrer"
            class="accessibility-padding"
            >{{ t("footer_legal_notice") }}
          </a>
    </div>
    <div class="registration-footer-element" :class="brandClass" v-if="c('link_cookie_policy')">
          <a
            :href="c('link_cookie_policy')"
            target="_blank"
            rel="noopener noreferrer"
            class="accessibility-padding"
            >{{ t("footer_cookie_policy") }}
        </a>
    </div>
    <!-- <div class="registration-footer-element" :class="brandClass" v-if="areEpaasAndTracyEnabled && isEpaasInitialized">
     <a
        target="_blank"
        href=""
        class="accessibility-padding"
        @click="fireCookieEvent($event)"
        @keydown="ariaClick"
        >{{ t("footer_cookie_policy") }}</a
      >
    </div> -->
    <div class="registration-footer-element" :class="brandClass" v-if="c('link_data_privacy')">
      <a
        :href="c('link_data_privacy')"
        target="_blank"
        rel="noopener noreferrer"
        class="accessibility-padding"
        >{{ t("footer_data_privacy") }}</a
      >
    </div>
    <hr v-if="c('show_footer_settings')" alt="" role="presentation">
    <div class="registration-footer-element footer-settings" v-if="c('show_footer_settings')" :class="brandClass" >
      <OneTippy
        :brandClass="brandClass"
        :name="'settingPopupTrigger'"
        v-if="true"
        :showInfoIcon="false"
        :placement="'top-start'"
        :maxWidth="450"
        :labelledBy="'tooltip-label'"
      >
      <template v-slot:externalcontent>
        <div class="custom-alert-settings" :class="brandClass">
          <div class="custom-confirm-title-settings" :class="brandClass">
            {{ t("footer_settings_display_mode") }}
          </div>
          <div class="custom-confirm-content-settings" :class="brandClass">
            <div class="radio_settings_container">
              <div @keydown="ariaClick" aria-labelledby="darkmode-label" role="button" tabindex="0" class="radio_settings" @click="selectDarkMode(true)" :class="darkModeSelected && 'selected'"></div>
              <div class="radio_settings_label" id="darkmode-label" aria-hidden="true">{{t("footer_settings_darkmode")}}</div>
              <div @keydown="ariaClick" aria-labelledby="lightmode-label" role="button" tabindex="0" class="radio_settings" @click="selectDarkMode(false)" :class="!darkModeSelected && 'selected'"></div>
              <div class="radio_settings_label" id="lightmode-label" aria-hidden="true">{{t("footer_settings_lightmode")}}</div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:externaltriggeringelement>
        <a
          :id="'settingPopupTrigger'"
          href="javascript:void(0)"
          tabindex="0"
          @keydown="ariaClick"
          class="accessibility-padding"
          >{{ t("footer_settings") }}</a
        >
      </template>
      </OneTippy>
    </div>
  </nav>
</div>
</template>

<script>
import OneLanguageSelection from "../../gcdm-one-language-selection/src/OneLanguageSelection";
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import { defineComponent,defineAsyncComponent } from 'vue';
export default defineComponent({
  mixins:[oneUtils.accessibilityMixin],
  name: "OneFooter",
  components: {
    OneLanguageSelection,    
    OneTippy: defineAsyncComponent(() =>
      import('../../../gcdm-one-library/gcdm-one-tippy/src/OneTippy')
    )
  },
  props:{
    profileStyle:{
      type: Boolean,
      required: false,
      default: false
    },
    brandClass:{
      type: String,
      required: true,
      default: '__b'
    },
    t:{
      type: Function,
      required: true
    },
    c:{
      type: Function,
      required: true
    },
  },
  data: () => ({
    isEpaasInitialized:false,
  }),
  mounted: function(){
    ((window['epaas'] && window['epaas'].api) || window).addEventListener('consentcontroller.api.initialized', ()=>{
      this.isEpaasInitialized = true;
    });
  },
  methods: {
    async selectDarkMode(selected){
      if(this.darkModeSelected!=selected){
        //switch the toggle
        this.darkModeSelected=selected;

        //replace query
        const oldQuery = Object.assign({}, oneUtils.utils.getQueryParams());
        if(oldQuery.isDarkmode){
          oldQuery.isDarkmode=selected+"";
          console.log('oldQuery: ',oldQuery)
          await this.$router.replace({query:oldQuery})
        }
        //reload page
        window.location.reload();
      }
    },
    fireCookieEvent: (e)=>{
      e.preventDefault();
      e.stopImmediatePropagation();
      const event = new CustomEvent("POLICY_CLICK");
      window.dispatchEvent(event); 
    }
  },
  computed:{
    darkModeSelected:{
      // getter
      get() {
        const queryParams = oneUtils.utils.getQueryParams();
        const brand = this.$store.state.configurationParams.brand;
        if(queryParams.isDarkmode){
          window.localStorage.setItem("oneid_darkmode_selected_"+brand, queryParams.isDarkmode)
        }
        return window.localStorage.getItem("oneid_darkmode_selected_"+brand)=="true";
      },
      // setter
      set(newValue) {
        const brand = this.$store.state.configurationParams.brand;
        //save in localstorage
        window.localStorage.setItem("oneid_darkmode_selected_"+brand, newValue);
      }
    },
    areEpaasAndTracyEnabled(){
      const areEpaasAndTracyEnabledGlobal = this.c("enable_epaas_&_tracy_tracking_global");
      const areEpaasAndTracyEnabledClient = this.c("enable_epaas_&_tracy_tracking");
      if (areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient !== undefined) {
           return areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient;
      }
      return areEpaasAndTracyEnabledGlobal;
    },
  }
});
</script>

<style lang="scss" scoped>
@import './styles/_variables.scss';
.registration-footer-container {
  display: flex;
  position: relative;
  width: 616px;
  flex-direction: column;
  justify-content: center;
  bottom: 0;
  left: 0;
  padding: 60px 128px 20px;
  hr{
    border-top: 1px solid $grey6;
    width: 100%;

    &.__rr {
      height: 1px;
      opacity: 0.3;
    }
  }
  .registration-footer-element {
    width: 50%;
    text-align: left;
    margin-top: 15px;
    margin-bottom: 15px;

    a {
      color: inherit;
    }
    a:hover {
      color: inherit;
    }
    &.__m{
      a{
        text-transform: uppercase;
        font-weight: bold;
        color: $miniLink;
      }
    }
    &.__rr {
      font-family: RivieraNights-Medium;
      font-size: 12px;
    }
  }
  @media screen and (max-width: 1024px) {
    width: 512px;
    padding: 60px 80px 20px;
  }
  @media screen and (max-width: 768px) {
    position: relative;
    width: 427px;
    padding: 60px 0px 60px 0;
    margin: 0 auto;
  }
  @media screen and (max-width: 480px) {
    width: auto;
    margin-left: 24px;
    margin-right: 24px;
  }
}
.profile-footer-container {
  background-color: $barGrey;
  padding: 20px 50px;
  display: flex;
  flex-direction: row-reverse;  
  justify-content: space-between;
  align-items: center;
  &.__alphabet{
    background: transparent;
    border-top: 1px solid $barGrey;
    padding: 25px 50px;
  }
  &.__rr {
    background-color: black;
    border-top: 1px solid white;
    padding: 1.5rem 50px;

    .footer-elements {
      .footer-element {
        a {
          color: rgba(white, 0.6) !important;
        }
      }
    }
  }
  &.__motorrad:not(.__d) {
    .footer-elements {
      .footer-element {
        a {
          font-weight: normal;
          text-decoration: underline !important;
          &:hover {
            color: $motorradDarkGrey !important;
            font-weight: bold;
          }
        }
      }
    }
  }
  .footer-elements{
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    hr{
      border-top: 1px solid black;
      width: 80vw;
      display: none;
    }
    .footer-element {
      padding-left: 10px;
      padding-right: 10px;
      font-weight: bold;
      &.footer-settings{
        margin-left: 72px;
      }
      &:hover{
        font-weight: bold;
        text-decoration: underline;
      }
      a {
        color: inherit;
        text-decoration: none !important;
      }
      a:hover {
        color: inherit;
        text-decoration: none;
      }
    }
  }
  &.__d{
    background-color: $bmwdarkmodebg;
    border-top: 1px solid white;
    &.__m{
      background-color: $minidarkmodebg;
    }
  }
  //mobile and tablet
  @media screen and (max-width: 768px) {
    justify-content: left;
    .footer-elements{
      flex-direction: column;
      align-items: baseline;
      margin-bottom: 15px;
      hr{
        display: block;
      }
      .footer-element{
        margin-bottom: 15px;
        &.footer-settings{
          margin-left: 0px;
          margin-top: 15px;
        }
      }
    }
  }
}
  .custom-alert-settings{
    background: white;
    width: 280px;
    padding: 5px 5px 5px;
    position: relative;
    &.__m{
        background-color: black;
    }
    &.__d{
      background-color: $bmwdarkmodebg;
      &.__m{
        background-color: black;
      }
    }
   
    .custom-confirm-title-settings{
      text-align: left;
      font-weight: bold;
      &.__d{
        color: white;
      }
    }
    .radio_settings_container{
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
    }
    .radio_settings{
      width: 9%;
      height: 24px;
      background-image: url('~@/assets/default/light/radio-unselected-default-light.svg');
      background-repeat: no-repeat;
      cursor: pointer;
      &:hover{
        outline: auto;
      }
      &.selected{
        background-image: url('~@/assets/default/light/radio-selected-default-light.svg');
      }
    }
    .radio_settings_label{
      font-size: 16px;
      margin: 0;
      line-height: 24px;
      width: 80%;
      text-align: left;
      margin-bottom: 16px;
      margin-left: 12px;
    }
  }
.accessibility-padding {
  position: relative;
  display: inline-block;
  padding: 13px;
  margin: -13px;
}
</style>
